import { render, staticRenderFns } from "./PerformanceEvolution.vue?vue&type=template&id=2e8d522b&scoped=true"
import script from "./PerformanceEvolution.vue?vue&type=script&lang=js"
export * from "./PerformanceEvolution.vue?vue&type=script&lang=js"
import style0 from "./PerformanceEvolution.vue?vue&type=style&index=0&id=2e8d522b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d522b",
  null
  
)

export default component.exports